import Vue from "vue";
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'
// import { Swiper, SwiperSlide } from "vue-awesome-swiper";

import "~/assets/scss/base/swiper.scss";

// console.log(Swiper.name, SwiperSlide.name)
Vue.use(VueAwesomeSwiper)
